export const generateEmail = () => {
  const domains = ['example.com', 'gmail.com', 'outlook.com', 'yahoo.com', 'proton.me']
  const user = Array.from(crypto.getRandomValues(new Uint8Array(8)))
    .map((n) => (n % 36).toString(36))
    .join('')
  const domain = domains[Math.floor(Math.random() * domains.length)]
  return `${user}@${domain}`
}
